// Test IDs for the OSS Ottawa one-page menu site.

export const HOME = {
  emergentLink: 'home-emergent-link',
  ageGate: 'age-gate-modal',
  ageGateConfirm: 'age-gate-confirm-btn',
  ageGateDecline: 'age-gate-decline-btn',
  heroSection: 'hero-section',
  heroTextBtn: 'hero-text-btn',
  heroMenuBtn: 'hero-menu-btn',
  promoBanner: 'promo-banner',
  qrSection: 'qr-section',
  qrImage: 'qr-image',
  menuSection: 'menu-section',
  productCard: (id) => `product-card-${id}`,
  productTextBtn: (id) => `product-text-btn-${id}`,
  stickyBar: 'sticky-bottom-bar',
  stickyCallBtn: 'sticky-call-btn',
  stickyTextBtn: 'sticky-text-btn',
  footer: 'site-footer',
};
